// ABOUTME: Dispatches a custom event when connected to the DOM.
// ABOUTME: Used in Turbo Stream replacements to trigger jQuery initialization listeners.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { name: String }

  connect() {
    this.element.dispatchEvent(new Event(this.nameValue, { bubbles: true }))
  }
}
